import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { GET_PREVIEW_PDF } from '../../state/lease_contract/types';
import { RESOURCE } from '../../config/constants/alerts';
import Schema from '../../classes/index';
import ShowPdf from '../pdf/ShowPdf';
import PropTypes from 'prop-types';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const spinnerIcon = <LoadingOutlined style={{ fontSize: 50 }} spin />;

const FormPreview = ({ getPreview, contractPdf, previewData, globalSpin }) => {

  useEffect(() => { getPreview(Schema.rentContract.preview(previewData)); }, []);

  return (
    <Spin spinning={globalSpin} indicator={spinnerIcon}>
      <div style={{ width: '60%', margin: 'auto' }}>
        <ShowPdf pdf={contractPdf} />
      </div>
    </Spin>
  );
};

FormPreview.propTypes = {
  contractPdf: PropTypes.string,
  getPreview: PropTypes.func,
  previewData: PropTypes.object,
  globalSpin: PropTypes.bool,
};

const data = (state) => ({
  previewData: state.contract.previewData,
  contractPdf: state.contract.contractPdf,
  globalSpin: state.download.globalSpin
});

const actions = (dispatch) => ({
  getPreview: payload => dispatch({ type: GET_PREVIEW_PDF, payload: { payload, resource: RESOURCE.GET_PREVIEW_PDF } }),
});

export default connect(data, actions)(FormPreview);